import React from 'react'
import { positionChoices } from '../utils/positions'

type PositionSelectProps = {
  value: string
  onChange: (value: string) => void
  positions: string[]
  allowEmpty?: boolean
  emptyLabel?: string
  className?: string
  ariaLabel?: string
  disabled?: boolean
}

const PositionSelect: React.FC<PositionSelectProps> = ({
  value,
  onChange,
  positions,
  allowEmpty = true,
  emptyLabel = 'Select position',
  className = 'select select-bordered w-full',
  ariaLabel = 'Position',
  disabled = false,
}) => {
  const choices = positionChoices(positions, value)
  return (
    <select
      className={className}
      value={value}
      aria-label={ariaLabel}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {allowEmpty ? <option value="">{emptyLabel}</option> : null}
      {choices.map((position) => (
        <option key={position} value={position}>
          {position}
        </option>
      ))}
    </select>
  )
}

export default PositionSelect
